/**
 * Trunnion AI - Dashboard API Endpoints
 */

import apiClient from './client';
import type { Execution, TokenUsageSummary } from '@/types';

const BASE = '/dashboard';

export interface DashboardOverview {
  totalWorkflows: number;
  activeWorkflows: number;
  totalExecutions: number;
  activeExecutions: number;
  successRate: number;
  totalAgents: number;
  activeAgents: number;
  recentAuditCount: number;
  tokenUsageToday: number;
  estimatedCostToday: number;
  systemHealth: 'healthy' | 'degraded' | 'unhealthy';
}

export interface ActiveRunsResponse {
  runs: Execution[];
  total: number;
}

export const dashboardApi = {
  getOverview: async (): Promise<DashboardOverview> => {
    const { data } = await apiClient.get(`${BASE}/overview`);
    return data;
  },

  getActiveRuns: async (): Promise<ActiveRunsResponse> => {
    const { data } = await apiClient.get(`${BASE}/active-runs`);
    return data;
  },

  getTokenUsageSummary: async (params?: {
    period?: 'day' | 'week' | 'month';
  }): Promise<TokenUsageSummary[]> => {
    const { data } = await apiClient.get(`${BASE}/token-usage`, { params });
    return data;
  },

  getRecentAudit: async (limit?: number): Promise<{
    events: Array<{
      id: string;
      timestamp: string;
      eventType: string;
      actorName: string;
      resourceName: string;
      classification: string;
    }>;
  }> => {
    const { data } = await apiClient.get(`${BASE}/recent-audit`, {
      params: { limit: limit ?? 10 },
    });
    return data;
  },
};
